import script from "./agents-alerts-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./agents-alerts-header.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__